let videoEls: HTMLIFrameElement[]
let endScrollHandle: any = null
let waiting = false
const fraction = 0.25
const waitingThreshold = 500
const youtubeOrigin = 'https://www.youtube.com'
const autoStartRegex = /(autostart=true)|(autoplay=1)|(autoPlay)/g

export const iframeVideoPluginInit = (): void => {
    videoEls = Array.from(
        document.querySelectorAll('iframe[src*="youtube.com"]')
    ) // select supported iframe Nodes and convert them into ordinary Array (so we can push more elements on the fly)
    // Parsing and categorizing the iframes videos
    if (videoEls.length > 0) {
        Array.prototype.forEach.call(videoEls, (videoEl) => {
            // check if supported or not supported video
            if (!videoEl.src.includes('rel=0&enablejsapi=1')) {
                videoEl.src = `${videoEl.src}?rel=0&enablejsapi=1`
            }

            if (videoEl.src.search(autoStartRegex) > 0) {
                videoEl.classList.add('playing')
                videoEl.classList.add('rhd-auto-play')
                videoEl.src = videoEl.src.replace(
                    autoStartRegex,
                    'autostart=false'
                )
                videoEl.onload = () => {
                    videoEl.classList.remove('playing')
                    scrollHandler()
                }
            }
        })

        // Remove listeners -- in case init() is called multiple times, the previously attached events have to be removed.
        window.removeEventListener('scroll', scrollHandler)
        window.removeEventListener('resize', scrollHandler) // OPTIONAL
        window.removeEventListener('load', scrollHandler) // OPTIONAL

        // Add listeners
        window.addEventListener('scroll', scrollHandler, false)
        window.addEventListener('resize', scrollHandler, false) // OPTIONAL
        window.addEventListener('load', scrollHandler, false) // OPTIONAL
    }
}

/**
 * this method is attached to Window by Arrow Function; so it can be removed safely by .removeEventListener()
 * @returns
 */
const scrollHandler = () => {
    if (waiting) {
        return
    }
    waiting = true
    if (endScrollHandle) {
        clearTimeout(endScrollHandle)
    }
    scrollHandlerHelper()
    setTimeout(() => {
        waiting = false
    }, waitingThreshold)
    endScrollHandle = setTimeout(() => {
        scrollHandlerHelper()
    }, waitingThreshold)
}

const scrollHandlerHelper = () => {
    Array.prototype.forEach.call(videoEls, (videoEl) => {
        isInViewPort(videoEl)
    })
}

const messageFn = (action: string) => {
    return JSON.stringify({
        event: 'command',
        func: `${action}Video`
    })
}

const isInViewPort = (videoEl: HTMLIFrameElement) => {
    const percentVisible = fraction,
        elemRect = videoEl.getBoundingClientRect(),
        elemTop = elemRect.top,
        elemBottom = elemRect.bottom,
        elemHeight = elemRect.height,
        overhang = elemHeight * (1 - percentVisible),
        isVisible =
            elemTop >= -overhang && elemBottom <= window.innerHeight + overhang

    if (isVisible) {
        videoEl.classList.add('playing')

        if (videoEl && videoEl.classList.contains('rhd-auto-play')) {
            videoEl.contentWindow?.postMessage(messageFn('play'), youtubeOrigin)
        }
    } else {
        // video is outside the ViewPort, pause
        if (videoEl.classList.contains('playing')) {
            // pause supported iframes
            videoEl.classList.remove('playing')
            videoEl.contentWindow?.postMessage(
                messageFn('pause'),
                youtubeOrigin
            )
        }
    }
}

export {}
